import React from "react";
import Layout from "../../components/Layout";
import OpenGraphTitle from "../../components/OpenGraphTitle";
import OpenGraphDescription from "../../components/OpenGraphDescription";
import Head from "../../components/head";
import { ServicesPageProvider } from "../../context/ServicesPageContext";
import { FranchiseeProvider } from "../../context/Franchisee";
import ServiceTitle from "../../components/ServiceTitle";
import ServicesDescription from "../../components/ServicesDescription";
import { Col, Row } from "react-bootstrap";

interface ServicesPageProps {
  /* add services page props here */
}

const Services: React.FC<ServicesPageProps> = () => (
  <FranchiseeProvider>
    <ServicesPageProvider>
      <Layout alternateFooter={true}>
        <Head
          slug="services"
          title="House Cleaning Services - Two Maids"
          description="Our house cleaners at Two Maids bring expert care and attention to every home. Let us handle the cleaning so you can enjoy a spotless space."
        />
        <OpenGraphTitle title="House Cleaning Services - Two Maids" />

        <OpenGraphDescription>
          Our house cleaners at Two Maids bring expert care and attention to every home. Let us handle the cleaning so you can enjoy a spotless space.
        </OpenGraphDescription>
        
        <ServiceTitle imageSrc="https://res.cloudinary.com/twomaidsengi/image/upload/v1724955999/hubsite-reskin/New%20Services%20Pages/services-main-image-crop.webp">Our Services</ServiceTitle>
        <div className="service-description">
          <Row className="service-description-section">
            <Col xs={6} sm={6} md={4} lg={2}>
              <a href="recurring-clean">
                <img
                  src="https://res.cloudinary.com/twomaidsengi/image/upload/v1724955992/hubsite-reskin/New%20Services%20Pages/recurring.svg"
                  loading="lazy"
                  className="service-description-section-svg"
                />
                <p className="service-description-icon-text">RECURRING<br />CLEANING</p>
              </a>
            </Col>
            <Col xs={6} sm={6} md={4} lg={2}>
              <a href="one-time-clean">
                <img
                  src="https://res.cloudinary.com/twomaidsengi/image/upload/v1724956390/hubsite-reskin/New%20Services%20Pages/one-time-clean-icon.svg"
                  loading="lazy"
                  className="service-description-section-svg"
                />
                <p className="service-description-icon-text">ONE-TIME-<br />CLEANING</p>
              </a>
            </Col>
            <Col xs={6} sm={6} md={4} lg={2}>
              <a href="move-in-move-out">
                <img
                  src="https://res.cloudinary.com/twomaidsengi/image/upload/v1724956421/hubsite-reskin/New%20Services%20Pages/move-in-move-out-icon.svg"
                  loading="lazy"
                  className="service-description-section-svg"
                />
                <p className="service-description-icon-text">MOVE IN - MOVE OUT CLEANING</p>
              </a>
            </Col>
            <Col xs={6} sm={6} md={4} lg={2}>
              <a href="deep-clean">
                <img
                  src="https://res.cloudinary.com/twomaidsengi/image/upload/v1724956428/hubsite-reskin/New%20Services%20Pages/deep-clean-icon.svg"
                  loading="lazy"
                  className="service-description-section-svg"
                />
                <p className="service-description-icon-text">DEEP<br />CLEANING</p>
              </a>
            </Col>
            <Col xs={6} sm={6} md={4} lg={2}>
              <a href="apartment-clean">
                <img
                  src="https://res.cloudinary.com/twomaidsengi/image/upload/v1724955990/hubsite-reskin/New%20Services%20Pages/apartment-clean.svg"
                  loading="lazy"
                  className="service-description-section-svg"
                />
                <p className="service-description-icon-text">APARTMENT<br />CLEANING</p>
              </a>
            </Col>
          </Row>

          <p>
            We’re proud to provide safe and reliable professional-grade cleaning supplies and products. Each of our teams of 
            Two Maids has been professionally trained to deliver high quality house cleaning services. We offer multiple cleaning 
            packages that are designed to meet the demands of any home owner. Whether you need your house cleaning 
            services on a regular basis or just one time, we have a cleaning option that's right for you. A comprehensive 
            description of each cleaning package is below.
          </p>
        </div>
        <ServicesDescription
          title="RECURRING CLEANING"
          imageSrc="https://res.cloudinary.com/twomaidsengi/image/upload/v1724955993/hubsite-reskin/New%20Services%20Pages/recurring-clean.webp"
          imageClassName="service-description-small-image"
          className="gray-background"
          link="recurring-clean"
        >
          <p className="mb-1">
            With this package, our team of Personal House 
            Cleaners will rotate between the Premium and 
            Touch Up service packages, performing tasks 
            related to each service during each visit.
          </p>
          <a href="recurring-clean" className="service-learn-more">Learn More</a>
        </ServicesDescription>
        <ServicesDescription
          title="ONE-TIME CLEANING"
          imageSrc="https://res.cloudinary.com/twomaidsengi/image/upload/v1724955996/hubsite-reskin/New%20Services%20Pages/one-time-clean.webp"
          imageClassName="service-description-small-image"
          link="one-time-clean"
        >
          <p className="mb-1">
            One-time cleaning services that fit your needs are our 
            specialty. With Design With Time, you guarantee your 
            priorities are addressed in their order of importance.
          </p>
          <a href="one-time-clean" className="service-learn-more">Learn More</a>
        </ServicesDescription>
        <ServicesDescription
          title="MOVE IN - MOVE OUT CLEANING"
          imageSrc="https://res.cloudinary.com/twomaidsengi/image/upload/v1724955994/hubsite-reskin/New%20Services%20Pages/move-in-move-out.webp"
          imageClassName="service-description-small-image"
          className="gray-background"
          link="move-in-move-out"
        >
          <p className="mb-1">
            Moving is stressful. With Two Maids' Move In & Move 
            Out Cleaning service, we help ease that stress to make 
            the moving process a little easier.
          </p>
          <a href="move-in-move-out" className="service-learn-more">Learn More</a>
        </ServicesDescription>
        <ServicesDescription
          title="DEEP CLEANING"
          imageSrc="https://res.cloudinary.com/twomaidsengi/image/upload/v1724955991/hubsite-reskin/New%20Services%20Pages/deep-clean.webp"
          imageClassName="service-description-small-image"
          link="deep-clean"
        >
          <p className="mb-1">
            Our professional Deep Cleaning Services tackle 
            the overlooked areas of the home, making it 
            sparkle like it’s brand new.
          </p>
          <a href="deep-clean" className="service-learn-more">Learn More</a>
        </ServicesDescription>
        <ServicesDescription
          title="APARTMENT CLEANING"
          imageSrc="https://res.cloudinary.com/twomaidsengi/image/upload/v1724955991/hubsite-reskin/New%20Services%20Pages/apartmentcleaning.webp"
          imageClassName="service-description-small-image"
          className="gray-background"
          link="apartment-clean"
        >
          <p className="mb-1">
            Living in an apartment, condominium, or townhome can be 
            particularly challenging, as these spaces can quickly become 
            cluttered and chaotic, especially if you have kids or pets. Two 
            Maids understands these unique challenges and the nuances of 
            apartment living, offering specialized cleaning services tailored to 
            meet your specific needs, ensuring your space remains pristine 
            and stress-free.
          </p>
          <a href="apartment-clean" className="service-learn-more">Learn More</a>
        </ServicesDescription>
      </Layout>
    </ServicesPageProvider>
  </FranchiseeProvider>
);
export default Services;